var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useCallback, useContext, useEffect, useMemo, useState, } from "react";
import { FormGroup, FormLabel, FormControl } from "react-bootstrap";
import { DataGrid } from "@mui/x-data-grid";
import { debounce } from "lodash";
import SubmissionContext from "../../contexts/submissionContext/submission-context";
import { getGridApiData } from "../../services/LookupService";
import formatRestApiEndpoint from "../../utils/FormatRestApiEndpoint";
export var ManageLookup = function (_a) {
    var cancel = _a.cancel, _b = _a.lookupInfo, lookupButtonId = _b.lookupButtonId, endpoint = _b.endpoint, queryParameters = _b.queryParameters, lookupType = _b.lookupType, tableHeaders = _b.tableHeaders, tableLabel = _b.tableLabel;
    var updateSubmission = useContext(SubmissionContext).updateSubmission;
    var _c = useState([]), gridRows = _c[0], setGridRows = _c[1];
    var _d = useState([]), gridCols = _d[0], setGridCols = _d[1];
    useEffect(function () {
        if (tableHeaders) {
            var formattedHeaders = tableHeaders.map(function (header) {
                return { field: header.key, headerName: header.label, flex: 50 };
            });
            setGridCols(formattedHeaders);
        }
    }, [tableHeaders]);
    var fetchGridRows = useCallback(function (apiEndpoint) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getGridApiData(apiEndpoint)];
                case 1:
                    _a = _b.sent(), success = _a.success, data = _a.data;
                    if (success && data) {
                        setGridRows(data.content);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        if (endpoint) {
            var lookupEndpoint = formatRestApiEndpoint(endpoint, queryParameters);
            fetchGridRows(lookupEndpoint);
        }
    }, [endpoint, queryParameters, fetchGridRows]);
    var searchTable = useCallback(function (searchTerm) {
        var queryParamsWithSearch = [
            {
                queryParameter: "q",
                value: searchTerm,
            },
        ];
        if (queryParameters)
            queryParamsWithSearch = __spreadArrays(queryParameters, queryParamsWithSearch);
        var lookupEndpoint = formatRestApiEndpoint(endpoint, queryParamsWithSearch);
        fetchGridRows(lookupEndpoint);
    }, [endpoint, fetchGridRows, queryParameters]);
    var debouncedSearchTable = useMemo(function () { return debounce(searchTable, 300); }, [searchTable]);
    var mapRowObjWithForm = function (row) {
        console.log(lookupButtonId);
        updateSubmission(row);
        cancel();
    };
    var renderDataGrid = function () { return (React.createElement("div", { style: { height: "100%" } },
        React.createElement(FormGroup, { style: { marginBottom: 20 } },
            React.createElement(FormLabel, null, "Search"),
            React.createElement(FormControl, { type: "text", placeholder: "Search " + (tableLabel ? tableLabel : "Table"), onChange: function (_a) {
                    var value = _a.target.value;
                    return debouncedSearchTable(value);
                } })),
        React.createElement(DataGrid, { rows: gridRows, columns: gridCols, density: "compact", autoHeight: true, disableColumnSelector: true, disableColumnFilter: true, disableColumnMenu: true, disableSelectionOnClick: true, hideFooter: true, onRowDoubleClick: function (_a) {
                var row = _a.row;
                return mapRowObjWithForm(row);
            } }))); };
    return React.createElement("div", null, lookupType === "table" && renderDataGrid());
};
//# sourceMappingURL=index.js.map